import { getUserRoles, getAccessToken } from './states';

export const services = {
  getUserRoles,
  getAccessToken,
};
